import React from "react";
import Icon from "../../../../YourAIAgents/components/components/icon";
import AnimatedText from "../../AnimatedText";
import LoadingDots from "../../LoadingDots";
import ModalCloseButton from "./ModalCloseButton";

const textareaWrapperStyle = { position: "relative" };

const textareaStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "5px",
  overflowX: "hidden",
  resize: "none",
  maxHeight: "60px",
};

const sendButtonBaseStyle = {
  position: "absolute",
  right: "10px",
  top: "10px",
  border: "none",
  width: 32,
  height: 32,
  borderRadius: "9999px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  transition: "background-color 0.15s ease, opacity 0.15s ease",
};

const PromptIntroStep = ({
  step,
  promptQuery,
  promptQueryError,
  onPromptQueryChange,
  onSubmit,
  onKeyDown,
  onClose,
}) => {
  if (step === 1) {
    return (
      <div className="formGroup">
        <p
          className="roundofaddprompt z-w-100 text-center"
          style={{ marginBottom: 0 }}
        >
          <Icon id="magicstar" /> Creating task
          <LoadingDots speed={100} />
        </p>
      </div>
    );
  }

  if (step === 5) {
    return (
      <div className="formGroup">
        <ModalCloseButton onClick={onClose} />
        <p
          className="roundofaddprompt z-w-100 text-center"
          style={{ marginBottom: 0, background: "#ffdddd" }}
        >
          <Icon id="magicstar" /> Something Went Wrong!
        </p>
      </div>
    );
  }

  return (
    <div className="formGroup">
      <ModalCloseButton onClick={onClose} />
      <p className="roundofaddprompt w-full">
        <Icon id="magicstar" />{" "}
        <AnimatedText text="What do you want to do?" speed={50} />
      </p>
      <div style={textareaWrapperStyle}>
        <textarea
          value={promptQuery}
          required
          placeholder="Start Typing ..."
          name="promptQuery"
          onChange={(event) => onPromptQueryChange(event.target.value)}
          onKeyDown={onKeyDown}
          className="input_od_addPrompt v3chat__content"
          style={textareaStyle}
          rows={1}
          onInput={(event) => {
            event.target.style.height = "auto";
            event.target.style.height = `${event.target.scrollHeight}px`;
          }}
        />
        {(() => {
          const isActive = (promptQuery || "").trim().length > 0;
          return (
            <button
              type="button"
              onClick={onSubmit}
              disabled={!isActive}
              aria-label="Send"
              style={{
                ...sendButtonBaseStyle,
                background: isActive ? "#020817" : "#e2e8f0",
                color: isActive ? "#ffffff" : "#94a3b8",
                cursor: isActive ? "pointer" : "not-allowed",
                opacity: isActive ? 1 : 0.7,
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="19" x2="12" y2="5" />
                <polyline points="5 12 12 5 19 12" />
              </svg>
            </button>
          );
        })()}
      </div>
      {promptQueryError && (
        <small style={{ color: "red" }}>Should not be empty</small>
      )}
    </div>
  );
};

export default PromptIntroStep;
